<template>
  <div id="export_result_btn">
    <!-- <v-btn class="mx-5" @click="onClickExport('xlsx')">XLSX</v-btn> -->
    <v-btn @click="onClickExport('csv')" >CSV</v-btn>
  </div>
</template>

<script>
  export default {
    name: 'AbrAdvanceSearchExportResult',


    methods:{
      onClickExport(formatType){
        this.$emit('formatType', formatType)
      }
    }
  }
</script>

<style scoped>

</style>